import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ReactElasticCarousel, { consts } from "react-elastic-carousel";
import Footer from "../../stories/Footer";
import MainCard from "../../stories/MainCard";
import classes from "./Landing.module.css";
import CarouselPagination from "../../stories/CarouselPagination";
import FeaturedCollectionCard from "../../stories/FeaturedCollectionCard";
import Tags from "../../stories/Tags";
import HeroSection from "../../stories/HeroSection";
import DesktopHeader from "../../stories/Header/DesktopHeader";
import { useLoaderData, useLocation } from "react-router-dom";
import { BaseURL, imageUrl } from "../../config/apiUrl";
import { Get } from "../../Axios/AxiosFunctions";
import FeaturedCardModal from "../../stories/FeaturedCardModal/FeaturedCardModal";
import { useDispatch } from "react-redux";
import { saveLocation } from "../../redux/common/commonSlice";
import { DotsLoader } from "../../stories/DotsLoader/DotsLoader";

function LandingPage() {
  // const [pageData, cmsData] = useLoaderData();
  const [isApiCalling, setIsApiCalling] = useState(true);
  const [featuredCards, setFeaturedCards] = useState([]);
  const [featuredCollections, setFeaturedCollections] = useState([]);
  const [popularCards, setPopularCards] = useState([]);
  const [recentlyAdded, setRecentlyAdded] = useState([]);
  const [tags, setTags] = useState([]);
  const [cmsData, setCmsData] = useState(null);
  // const {
  //   featuredCards,
  //   featuredCollections,
  //   popularCards,
  //   recentlyAdded,
  //   tags,
  // } = pageData;
  const [selectTag, setSelectTag] = useState(null);
  const [selectedElemenet, setSelectedElement] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  // getData
  const getData = async () => {
    const url = BaseURL("cards/home");
    const cmsUrl = BaseURL("cms/pages/all?pages=home");
    setIsApiCalling(true);
    const [response, cmsResponse] = await Promise.all([Get(url), Get(cmsUrl)]);
    setIsApiCalling(false);

    if (response !== undefined) {
      const [_pageData, _cmsData] = [
        response?.data?.data,
        cmsResponse?.data?.data?.pages,
      ];

      const {
        featuredCards,
        featuredCollections,
        popularCards,
        recentlyAdded,
        tags,
      } = _pageData;
      setFeaturedCards(featuredCards);
      setFeaturedCollections(featuredCollections);
      setPopularCards(popularCards);
      setRecentlyAdded(recentlyAdded);
      setTags(tags);
      setCmsData(_cmsData);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isApiCalling) {
    return (
      <div className={classes?.center}>
        <DotsLoader />
      </div>
    );
  }

  return (
    <div>
      <DesktopHeader />
      <HeroSection
        heading={cmsData?.heading}
        text={
          cmsData?.description ||
          "Create and print your own custom trading cards and card games!"
        }
        bgImage={imageUrl(cmsData?.bg_image)}
        bgImageHash={cmsData?.bg_image_s}
        foregroungImage={imageUrl(cmsData?.cover_image)}
        foregroungImageHash={cmsData?.cover_image_s}
      />
      {/* Another Section */}
      <section className={classes.mt80}>
        <Container fluid className={classes.container}>
          <Row>
            <Col xl={8} lg={6}>
              {/* Recently Added Row */}
              <Row className={classes.recentlyAddedRow} id="recentlyAdded">
                <h2>Recently Added</h2>
                <ReactElasticCarousel
                  breakPoints={carouselSetting}
                  renderPagination={CarouselPagination}
                >
                  {recentlyAdded?.map((item, index) => (
                    <MainCard
                      data={item}
                      key={index}
                      setSelectedElement={setSelectedElement}
                      setIsDetailModalOpen={setIsDetailModalOpen}
                      // onClick={() => {
                      //   setSelectedElement(item);
                      //   setIsDetailModalOpen(true)
                      // }}
                    />
                  ))}
                </ReactElasticCarousel>
              </Row>
              {/* Featured Added Row */}
              <Row className={classes.featuredRow}>
                <h2>Featured</h2>
                <ReactElasticCarousel
                  breakPoints={carouselSetting}
                  renderPagination={CarouselPagination}
                >
                  {featuredCards?.map((item, index) => (
                    <MainCard
                      data={item}
                      key={index}
                      setSelectedElement={setSelectedElement}
                      setIsDetailModalOpen={setIsDetailModalOpen}
                      // onClick={() => {
                      //   setSelectedElement(item);
                      //   setIsDetailModalOpen(true);
                      // }}
                    />
                  ))}
                </ReactElasticCarousel>
              </Row>
              {/* Popular Added Row */}
              <Row className={classes.featuredRow}>
                <h2>Popular</h2>
                <ReactElasticCarousel
                  breakPoints={carouselSetting}
                  renderPagination={CarouselPagination}
                >
                  {popularCards?.map((item, index) => (
                    <MainCard
                      data={item}
                      key={index}
                      setSelectedElement={setSelectedElement}
                      setIsDetailModalOpen={setIsDetailModalOpen}
                      // onClick={() => {
                      //   setSelectedElement(item);
                      //   setIsDetailModalOpen(true);
                      // }}
                    />
                  ))}
                </ReactElasticCarousel>
              </Row>
            </Col>
            <Col xl={4} lg={6}>
              <Row className={classes.featuredCollections}>
                <h3>Featured Collections</h3>
                {featuredCollections.map((item, index) => (
                  <Col md={12} key={index}>
                    <FeaturedCollectionCard
                      data={{
                        image: imageUrl(item?.cards[0]?.photo),
                        title: item?.name,
                        description: item?.description,
                        _id: item?._id,
                      }}
                      setSelectedElement={setSelectedElement}
                      setIsDetailModalOpen={setIsDetailModalOpen}
                      // onClick={() => {
                      //   setSelectedElement(item);
                      //   setIsDetailModalOpen(true);
                      // }}
                    />
                  </Col>
                ))}
              </Row>
              <Row className={classes.mt80}>
                <Tags setter={setSelectTag} state={selectTag} data={tags} />
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Footer */}
      <Footer containerClass={classes.container} />

      {selectedElemenet && (
        <FeaturedCardModal
          show={isDetailModalOpen}
          setShow={setIsDetailModalOpen}
          data={selectedElemenet}
          isCarousel={selectedElemenet?.cards?.length > 0}
        />
      )}
    </div>
  );
}

export default LandingPage;

export const loader = async () => {
  const url = BaseURL("cards/home");
  const cmsUrl = BaseURL("cms/pages/all?pages=home");
  try {
    const [response, cmsResponse] = await Promise.all([
      Get(url, "", false, true),
      Get(cmsUrl, "", false, true),
    ]);

    return [response?.data?.data, cmsResponse?.data?.data?.pages];
  } catch (error) {
    throw error;
  }
};

const carouselSetting = [
  { width: 1, itemsToShow: 1, showArrows: false },
  {
    width: 500,
    itemsToShow: 2,
    itemsToScroll: 2,
    pagination: false,
    showArrows: false,
    itemPadding: [0, 10],
  },
  { width: 850, itemsToShow: 3, showArrows: false, itemPadding: [0, 10] },
];
